import appointmentServiceReducer from 'modules/appointment/services/reducers';
import authServiceReducer from 'modules/auth/services/reducers';
import customerServiceReducer from 'modules/customer/services/reducers';
import settingServiceReducer from 'modules/settingService/services/reducers';
import settingStaffReducer from 'modules/settingStaff/services/reducers';
import uiServiceReducer from 'services/UI/reducer';
import shopServiceReducer from 'services/shop/reducers';

const rootReducer = {
  ui: uiServiceReducer,
  appointment: appointmentServiceReducer,
  settingService: settingServiceReducer,
  settingStaff: settingStaffReducer,
  customer: customerServiceReducer,
  auth: authServiceReducer,
  shop: shopServiceReducer,
};

export default rootReducer;
